import { getData } from "./apiUtils";
import * as CONFIG from '../utils/config'

export function getAllTemplatesByGroupId(id) {
    return getData(CONFIG.GET_ALL_TEMPLATES_BY_GROUP_ID_URL() + id);
}

export function getTemplateById(id) {
    return getData(CONFIG.GET_TEMPLATES_BY_ID_URL() + id);
}
